<div class="flex flex-col h-screen w-screen bg-gray-100">
  <!-- Navbar -->
  <nav class="bg-gray-900 flex-shrink-0 z-50">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="flex h-16 items-center justify-between">
        <div class="flex items-center">
          <div class="flex-shrink-0 flex items-center gap-2">
            <!-- Consortium Selector (Navbar) -->
            <div class="hidden md:block relative" *ngIf="currentUser?.consorcios?.length > 0">
              <button (click)="toggleConsorcioMenu()"
                class="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-3 py-1.5 rounded-lg text-xs font-bold transition-all border border-gray-700 shadow-sm min-w-[120px] justify-between">
                <span class="truncate">{{ selectedConsorcio?.nombre || 'Seleccionar...' }}</span>
                <ion-icon [name]="consorcioMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
                  class="opacity-60"></ion-icon>
              </button>

              <!-- Custom Dropdown Menu -->
              <div *ngIf="consorcioMenuOpen"
                class="absolute left-0 mt-2 w-56 origin-top-left rounded-xl bg-gray-900 border border-gray-700 shadow-2xl z-[100] py-1 overflow-hidden animate-fade-in animate-slide-up">
                <div class="px-3 py-2 border-b border-gray-800 bg-gray-950">
                  <p class="text-[10px] uppercase tracking-widest text-gray-500 font-bold">Mis Consorcios</p>
                </div>
                <div class="max-h-60 overflow-y-auto custom-scrollbar">
                  <button *ngFor="let c of currentUser?.consorcios" (click)="onConsorcioChange(c.id)"
                    class="w-full text-left px-4 py-3 text-sm transition-all flex items-center justify-between group"
                    [class.bg-blue-600]="selectedConsorcio?.id === c.id"
                    [class.text-white]="selectedConsorcio?.id === c.id"
                    [class.text-gray-300]="selectedConsorcio?.id !== c.id"
                    [class.hover:bg-gray-800]="selectedConsorcio?.id !== c.id">
                    <span class="truncate">{{ c.nombre }}</span>
                    <ion-icon *ngIf="selectedConsorcio?.id === c.id" name="checkmark-circle"
                      class="text-white"></ion-icon>
                    <ion-icon *ngIf="selectedConsorcio?.id !== c.id" name="business-outline"
                      class="opacity-0 group-hover:opacity-40"></ion-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-4 flex items-baseline space-x-4">
            <!-- Admin/Operator Nav -->
            <ng-container *ngIf="currentUser?.role >= 5">
              <a routerLink="/tickets" routerLinkActive="bg-gray-700 text-white"
                class="text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium decoration-0">Tickets</a>
              <a routerLink="/whatsapp" routerLinkActive="bg-gray-700 text-white"
                class="text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium decoration-0">Whatsapp</a>
              <a routerLink="/unidades" routerLinkActive="bg-gray-700 text-white"
                class="text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium decoration-0">Unidades</a>
              <a routerLink="/pagos" routerLinkActive="bg-gray-700 text-white"
                class="text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium decoration-0">Pagos</a>

              <!-- Gestión Dropdown -->
              <div class="relative inline-block text-left group">
                <button (click)="toggleGestionMenu()"
                  class="flex items-center gap-1 text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium transition-all group-hover:text-white">
                  <span>Gestión</span>
                  <ion-icon [name]="gestionMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
                    class="text-[10px] opacity-50"></ion-icon>
                </button>

                <!-- Dropdown Menu -->
                <div *ngIf="gestionMenuOpen"
                  class="absolute left-0 mt-2 w-48 origin-top-left rounded-xl bg-gray-900 border border-gray-700 shadow-2xl z-[100] py-1 overflow-hidden animate-fade-in animate-slide-up">
                  <a routerLink="/presupuestos" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="document-text-outline" class="text-lg opacity-70"></ion-icon>
                    Presupuestos
                  </a>
                  <a routerLink="/reportes" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="pie-chart-outline" class="text-lg opacity-70"></ion-icon>
                    Reportes
                  </a>
                  <a routerLink="/repositorio" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="library-outline" class="text-lg opacity-70"></ion-icon>
                    Repositorio
                  </a>
                  <a routerLink="/inventario" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="cube-outline" class="text-lg opacity-70"></ion-icon>
                    Inventario
                  </a>
                  <a routerLink="/bancos" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="cash-outline" class="text-lg opacity-70"></ion-icon>
                    Extracto Bancario
                  </a>
                  <a routerLink="/seguimiento/empleados" (click)="toggleGestionMenu()"
                    routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="eye-outline" class="text-lg opacity-70"></ion-icon>
                    Seguimiento Empleados
                  </a>
                  <a routerLink="/seguimiento/proveedores" (click)="toggleGestionMenu()"
                    routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="construct-outline" class="text-lg opacity-70"></ion-icon>
                    Seguimiento Proveedores
                  </a>
                  <a routerLink="/sugerencias" (click)="toggleGestionMenu()" routerLinkActive="bg-blue-600 text-white"
                    class="block px-4 py-3 text-sm text-gray-300 hover:bg-gray-800 hover:text-white transition-all decoration-0 flex items-center gap-2">
                    <ion-icon name="bulb-outline" class="text-lg opacity-70"></ion-icon>
                    Sugerencias
                  </a>
                </div>
              </div>

              <a routerLink="/calendario" routerLinkActive="bg-gray-700 text-white"
                class="text-gray-300 hover:bg-gray-700 hover:text-white rounded-md px-3 py-2 text-sm font-medium decoration-0">Calendario</a>
            </ng-container>


          </div>

        </div>

        <div class="hidden md:block">
          <div class="ml-4 flex items-center md:ml-6">
            <button type="button" (click)="toggleNotificationsMenu()"
              class="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
              <span class="absolute -inset-1.5"></span>
              <span class="sr-only">View notifications</span>
              <ion-icon name="notifications-outline" class="h-6 w-6"></ion-icon>
              <!-- Badge -->
              <span *ngIf="unreadCount > 0"
                class="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center font-bold">
                {{ unreadCount > 9 ? '9+' : unreadCount }}
              </span>
            </button>

            <!-- Notifications Dropdown -->
            <div *ngIf="notificationsMenuOpen"
              class="absolute right-0 z-50 mt-2 w-80 origin-top-right rounded-xl bg-gray-900 border border-gray-700 shadow-2xl overflow-hidden"
              style="top: 48px;">
              <div class="px-4 py-3 border-b border-gray-700 flex justify-between items-center">
                <p class="text-sm text-white font-medium">Notificaciones</p>
                <button *ngIf="notifications.length > 0" (click)="fcmService.markAllAsRead()"
                  class="text-xs text-blue-400 hover:text-blue-300">Marcar todas como leídas</button>
              </div>
              <div class="max-h-80 overflow-y-auto">
                <div *ngIf="notifications.length === 0" class="px-4 py-8 text-center text-gray-500">
                  <ion-icon name="notifications-off-outline" class="text-4xl mb-2"></ion-icon>
                  <p class="text-sm">No hay notificaciones</p>
                </div>
                <div *ngFor="let notification of notifications" (click)="onNotificationClick(notification)"
                  class="px-4 py-3 hover:bg-gray-800 cursor-pointer border-b border-gray-800 transition-colors"
                  [ngClass]="{'bg-gray-700': !notification.read}">
                  <div class="flex items-start gap-3">
                    <div class="flex-shrink-0 mt-0.5">
                      <ion-icon [name]="notification.type === 'whatsapp' ? 'logo-whatsapp' : 'ticket-outline'"
                        [class.text-green-500]="notification.type === 'whatsapp'"
                        [class.text-blue-500]="notification.type === 'ticket'" class="text-lg"></ion-icon>
                    </div>
                    <div class="flex-1 min-w-0">
                      <p class="text-sm text-white font-medium truncate">{{ notification.title }}</p>
                      <p class="text-xs text-gray-400 truncate">{{ notification.body }}</p>
                      <p class="text-xs text-gray-500 mt-1">{{ notification.timestamp | date:'dd/MM HH:mm' }}</p>
                    </div>
                    <div *ngIf="!notification.read" class="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0 mt-2"></div>
                  </div>
                </div>
              </div>
              <div *ngIf="notifications.length > 0" class="px-4 py-2 border-t border-gray-700">
                <button (click)="fcmService.clearAll(); notificationsMenuOpen = false"
                  class="text-xs text-gray-400 hover:text-gray-300 w-full text-center">Borrar todas</button>
              </div>
            </div>

            <!-- Profile dropdown -->
            <div class="relative ml-3">
              <div>
                <button type="button" (click)="toggleUserMenu()"
                  class="relative flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                  id="user-menu-button" aria-expanded="false" aria-haspopup="true">
                  <span class="absolute -inset-1.5"></span>
                  <span class="sr-only">Open user menu</span>
                  <div class="h-8 w-8 rounded-full bg-gray-700 flex items-center justify-center text-white font-bold">
                    <ion-icon name="person" class="text-lg"></ion-icon>
                  </div>
                </button>
              </div>

              <!-- Dropdown menu -->
              <div *ngIf="userMenuOpen"
                class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-gray-800 py-1 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-700"
                role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
                <div class="px-4 py-3 border-b border-gray-700">
                  <p class="text-sm text-white font-medium">Cuenta</p>
                </div>
                <a routerLink="/perfil" (click)="toggleUserMenu()"
                  class="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-150 ease-in-out cursor-pointer"
                  role="menuitem" tabindex="-1" id="user-menu-item-0">Perfil</a>
                <a routerLink="/ajustes" (click)="toggleUserMenu()"
                  class="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-150 ease-in-out cursor-pointer"
                  role="menuitem" tabindex="-1" id="user-menu-item-1">Configuraciones</a>
                <div class="border-t border-gray-700 my-1"></div>
                <a (click)="logout()"
                  class="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white transition-colors duration-150 ease-in-out cursor-pointer"
                  role="menuitem" tabindex="-1" id="user-menu-item-2">Cerrar Sesión</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Menu Button -->
        <div class="-mr-2 flex md:hidden">
          <!-- Mobile menu button -->
          <button type="button" (click)="toggleMobileMenu()"
            class="relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            aria-controls="mobile-menu" aria-expanded="false">
            <span class="absolute -inset-0.5"></span>
            <span class="sr-only">Open main menu</span>
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <ion-icon [name]="mobileMenuOpen ? 'close' : 'menu'" class="block h-6 w-6" aria-hidden="true"></ion-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile menu -->
    <div class="md:hidden bg-gray-900" id="mobile-menu" *ngIf="mobileMenuOpen">
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <!-- Mobile Consortium Selector -->
        <div class="mb-4 px-3" *ngIf="currentUser?.consorcios?.length > 0">
          <div class="bg-gray-800 rounded-xl p-3 border border-gray-700 shadow-inner">
            <p class="text-[10px] uppercase tracking-widest text-gray-500 font-bold mb-3 pl-1">Consorcio Activo</p>
            <div class="grid grid-cols-1 gap-2">
              <button *ngFor="let c of currentUser?.consorcios" (click)="onConsorcioChange(c.id)"
                class="flex items-center justify-between p-3 rounded-xl transition-all active:scale-95"
                [class.bg-blue-600]="selectedConsorcio?.id === c.id" [class.text-white]="selectedConsorcio?.id === c.id"
                [class.bg-gray-900]="selectedConsorcio?.id !== c.id"
                [class.text-gray-400]="selectedConsorcio?.id !== c.id">
                <div class="flex items-center gap-3">
                  <ion-icon [name]="selectedConsorcio?.id === c.id ? 'business' : 'business-outline'"></ion-icon>
                  <span class="font-bold text-sm">{{ c.nombre }}</span>
                </div>
                <ion-icon *ngIf="selectedConsorcio?.id === c.id" name="radio-button-on"></ion-icon>
                <ion-icon *ngIf="selectedConsorcio?.id !== c.id" name="radio-button-off" class="opacity-30"></ion-icon>
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="currentUser?.role >= 5">
          <a routerLink="/tickets" routerLinkActive="bg-gray-700 text-white"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0">Tickets</a>
          <a routerLink="/whatsapp" routerLinkActive="bg-gray-700 text-white"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0">Whatsapp</a>
          <a routerLink="/unidades" routerLinkActive="bg-gray-700 text-white"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0">Unidades</a>
          <a routerLink="/pagos" routerLinkActive="bg-gray-700 text-white"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0">Pagos</a>

          <!-- Mobile Gestión Section -->
          <div class="border-t border-gray-800 my-2 pt-2">
            <p class="px-3 text-[10px] uppercase tracking-widest text-gray-500 font-black mb-2">Gestión</p>
            <a routerLink="/presupuestos" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="document-text-outline"></ion-icon> Presupuestos
            </a>
            <a routerLink="/reportes" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="pie-chart-outline"></ion-icon> Reportes
            </a>
            <a routerLink="/repositorio" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="library-outline"></ion-icon> Repositorio
            </a>
            <a routerLink="/inventario" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="cube-outline"></ion-icon> Inventario
            </a>
            <a routerLink="/bancos" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="cash-outline"></ion-icon> Extracto Bancario
            </a>
            <a routerLink="/seguimiento/empleados" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="eye-outline"></ion-icon> Seguimiento Empleados
            </a>
            <a routerLink="/seguimiento/proveedores" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="construct-outline"></ion-icon> Seguimiento Proveedores
            </a>
            <a routerLink="/sugerencias" routerLinkActive="bg-gray-700 text-white"
              class="text-gray-400 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0 flex items-center gap-2">
              <ion-icon name="bulb-outline"></ion-icon> Sugerencias
            </a>
          </div>

          <a routerLink="/calendario" routerLinkActive="bg-gray-700 text-white"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block rounded-md px-3 py-2 text-base font-medium decoration-0">Calendario</a>
        </ng-container>



      </div>
    </div>
  </nav>

  <!-- Scrollable Area -->
  <div class="flex-1 overflow-hidden flex flex-col">

    <main class="flex-1 flex flex-col min-h-0">
      <div class="w-full flex-1 flex flex-col">
        <!-- Your content -->
        <div class="flex-1 relative h-full">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
  </div>
</div>